// extracted by mini-css-extract-plugin
export default {"TwoDimsListFeature":"wc_a bhl_b","TwoDimsListFeature__item":"wc_b bhl_we","TwoDimsListFeature__item__text":"wc_c bhl_vt"};